import styled, { DefaultTheme } from 'styled-components'

import { down } from '@Globals/Style/breakpoints'
import { mobilePadding } from '@Globals/Style/mixins'

export type ContainerWidth = keyof DefaultTheme['cmsModule']['width']

interface ContainerProps {
  noPaddingPhablet?: boolean
  width?: ContainerWidth
}

const Container = styled.div<ContainerProps>`
  width: 100%;
  margin-bottom: 20px;
  max-width: ${({
    theme: { cmsModule: { width: widths } },
    width,
  }) => widths[width || ''] ?? widths.small};

  ${mobilePadding}

  ${({ noPaddingPhablet }) => noPaddingPhablet && `
    ${down('phablet')} {
      padding-right: 0px;
      padding-left: 0px;
    }
  `};

  ol {
    list-style-type: decimal;
    margin: 0 0 18px 25px;

    li {
      padding-left: 3px;
      margin-bottom: 5px;
    }
  }
`

export default Container
